module.exports = __webpack_public_path__ + "static/img/suchunyuan.f097cb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_h5/suchunyuan.jpg
// module id = 9vNI
// module chunks = 0